module.exports = __webpack_public_path__ + "static/media/Salmen.2e4fc27b.jpg";